import { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import api from '../services/api';
import '../Login.css';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const email = params.get('email');
  const navigate = useNavigate();

  const [otp, setOtp] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();

    if (password !== confirm) {
      return setError('Passwords do not match');
    }

    setLoading(true);
    setError('');

    try {
      await api.post('/auth/reset-password', {
        email,
        otp,
        newPassword: password
      });

      // ✅ SUCCESS → LOGIN
      navigate('/login');
    } catch (err) {
      setError(
        err.response?.data?.error ||
        'Invalid OTP or expired. Try again.'
      );
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h2 className="login-title">Create new password</h2>

        <p style={{ fontSize: 14, color: '#6b7280', marginBottom: 24 }}>
          Enter the OTP sent to <strong>{email}</strong>
        </p>

        {error && <div className="custom-alert">{error}</div>}

        <form onSubmit={submit}>
          <input
            className="form-input-custom reset-input"
            placeholder="OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            required
          />

          <input
            type="password"
            className="form-input-custom reset-input"
            placeholder="New password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <input
            type="password"
            className="form-input-custom reset-input"
            placeholder="Confirm password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
          />

          <button className="submit-btn" disabled={loading}>
            {loading ? 'Resetting...' : 'Reset password'}
          </button>
        </form>
      </div>
    </div>
  );
}
